import React from "react";
import { selectedAuthSession } from "@src/ducks/slices/auth.slice";
import { PayPalButtons, usePayPalScriptReducer } from "@paypal/react-paypal-js";
import { View, useWindowDimensions, ActivityIndicator } from "react-native";
import { useRoute } from "@react-navigation/native";
import { useAppSelector } from "@src/ducks/ducksHook";
import { useLobbyService } from "@src/ducks/hooks";
import useStyles from "./styles.css";
import moment from "moment";
import _ from "lodash";

const PaypalButtons = () => {
  const styles = useStyles();
  const route = useRoute<any>();
  const { height } = useWindowDimensions();
  const amount = route?.params?.amount;
  const currency = route?.params?.currency;
  const productId = route?.params?.productId;
  const isJadeEgg = route?.params?.isJadeEgg;
  const { onPurchaseItem } = useLobbyService();
  const [{ isPending }] = usePayPalScriptReducer();
  const session = useAppSelector(selectedAuthSession);

  return (
    <>
      {isPending && (
        <View style={[styles.v_spinner, { height: height * 0.2}]}>
          <ActivityIndicator
            animating
            size="large"
            color="black"
            style={[styles.indicator]}
          />
        </View>
      )}
      <PayPalButtons
        forceReRender={[amount, currency]}
        fundingSource={undefined}
        createOrder={(data, actions) => {
          return actions.order
            .create({
              purchase_units: [
                {
                  amount: {
                    currency_code: currency,
                    value: amount,
                  },
                },
              ],
            })
            .then((orderId) => {
              // Your code here after create the order
              return orderId;
            });
        }}
        onApprove={function (data, actions: any) {
          return actions.order.capture().then(function (details: any) {
            // Your code here after capture the order
            const purchase_units = details.purchase_units[0] || {};

            console.log("details.purchase_units", purchase_units);

            if (details.status === "COMPLETED" && !_.isEmpty(purchase_units)) {
              const create_time = moment(new Date(details.create_time));
              const params = {
                isJadeEgg,
                paymentTypeID: purchase_units?.soft_descriptor ? 2 : 1,
                type: route?.params?.type,
                isShop: route?.params?.isShop,
                silverCoin: route?.params?.silver,
                isSubscription: route?.params?.isSubscription,
                userID: session.userId,
                amount: _.toNumber(purchase_units?.amount?.value ?? 0),
                currency: purchase_units?.amount?.currency_code ?? "USD",
                status: details.status,
                transactionNo: details.id,
                purchaseItem: productId,
                transactionDate: create_time.format("YYYY-MM-DD HH:mm:ss"),
                emailAddress: details.payer.email_address,
              };

              onPurchaseItem(params);
            }
          });
        }}
      />
    </>
  );
};

export default React.memo(PaypalButtons);
